import { storageAvailable } from "@toruslabs/openlogin-utils";

const { VITE_BACKEND_API_URL, VITE_BUILD_ENV } = import.meta.env as Record<string, string>;

const baseUrl = window.location.origin;
const baseRoute = baseUrl + import.meta.env.BASE_URL;

const appVersion = import.meta.env.VITE_TORUS_BUILD_VERSION;

export default {
  baseRoute,
  appVersion,
  api: VITE_BACKEND_API_URL,
  commonApiHost: "https://common-api.tor.us",
  buildEnv: VITE_BUILD_ENV || "production",
  storageAvailability: {
    local: storageAvailable("localStorage"),
    session: storageAvailable("sessionStorage"),
  } as Record<string, boolean>,
  sentrySampleRate: "0.1",
  sentryTransactionSampleRate: "0.001",
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
};
